// extracted by mini-css-extract-plugin
export default {"form_container":"styles_form_container__SFsA+","input":"styles_input__RQlEu","btn_submit":"styles_btn_submit__bDT3I"};